import React from 'react';

const fmtCurrency = (n) => '$' + new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Number.isFinite(n) ? n : 0);

const ValueGapResults = ({ wealth, totals, selection, currentValue, valueGap, onBack, onComplete }) => {
  return (
    <div className="flex justify-center bg-succession-surface px-4 pt-2 pb-6">
      <div className="w-full max-w-3xl">
        <div className="mb-4">
          <button type="button" onClick={onBack} className="text-succession-primary hover:underline" aria-label="Go back">← Back</button>
        </div>
        <h1 className="text-3xl md:text-4xl font-semibold text-succession-foreground mb-2">Your Value Gap</h1>
        <p className="text-succession-muted mb-4">Value Gap = Wealth Goal − Current Value</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 rounded border border-succession-border bg-white">
            <div className="text-succession-muted text-sm">Wealth Goal</div>
            <div className="text-2xl font-semibold text-succession-foreground">{fmtCurrency(wealth.X)}</div>
          </div>
          <div className="p-4 rounded border border-succession-border bg-white">
            <div className="text-succession-muted text-sm">Current Simplified Value</div>
            <div className="text-2xl font-semibold text-succession-foreground">{fmtCurrency(currentValue)}</div>
            <div className="text-succession-muted text-xs mt-1">Multiple {selection.multiple.toFixed(2)}x • EBITDA {fmtCurrency(totals.recasted_ebitda)}</div>
          </div>
          <div className="md:col-span-2 p-5 rounded border border-succession-border" style={{ background: 'var(--succession-primary)' }}>
            <div className="text-white text-sm mb-1">Your Value Gap</div>
            <div className="text-3xl font-bold text-white">{fmtCurrency(valueGap)}</div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button type="button" className="bg-succession-primary text-white px-4 py-2 rounded hover:bg-succession-primary/90" onClick={onComplete}>Finish</button>
        </div>
      </div>
    </div>
  );
};

export default ValueGapResults;


